import { CSSProperties } from "@material-ui/styles";
import { makeStyles } from "@saleor/macaw-ui";

const freezeCell: CSSProperties = {
  position: "sticky",
  right: 0,
  width: 48,
  padding: 0,
  borderRadius: "0px 2px 2px 0px",
  background: "inherit",
  textAlign: "center"
};

const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: "40px",
      overflowX: "auto",
      width: "100%",
      borderCollapse: "collapse",
      borderBottom: 0,
      borderRadius: "8px",
      "& .MuiTableHead-root .MuiTableCell-root:first-child": {
        borderTopLeftRadius: "8px"
      },
      "& .MuiTableRow-root:before": {
        display: "none"
      },
      "& .MuiTableHead-root .MuiTableCell-root:last-child": {
        borderTopRightRadius: "8px"
      },
      "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root:first-child": {
        borderBottomLeftRadius: "8px"
      },
      "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root:last-child": {
        borderBottomRightRadius: "8px"
      },
      "& .MuiTableCell-head": {
        "& *": {
          color: theme.palette.grey[900]
        }
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
      // "& .MuiTableCell-root": {
      //   padding: "1.2rem 1.2rem ",
      //   border: "1px solid #E0E0E0",
      //   color: "#FF0000",
      //   "& span": {
      //     // color: theme.palette.grey[900]
      //   }
      // }
    },
    col100: {
      width: 100,
      color: theme.palette.grey[900]
    },
    col120: {
      width: 120,
      color: theme.palette.grey[900]
    },
    col160: {
      width: 160,
      color: theme.palette.grey[900]
    },
    colMin160: {
      textWrap: "nowrap",
      minWidth: 160,
      color: theme.palette.grey[900]
    },
    col190: {
      minWidth: 190,
      color: theme.palette.grey[900]
    },
    col180: {
      width: 180,
      color: theme.palette.grey[900]
    },
    col340: {
      width: 340,
      color: theme.palette.grey[900]
    },
    itemNo: {
      textAlign: "left"
    },
    flip: {
      transform: "rotate(180deg) scaleX(-1)"
    },
    estDate: {
      color: "#222222"
    },
    estDateNotMatch: {
      color: `${theme.palette.error.light} !important`
    },
    colQty: {
      marginRight: 55
    },
    colQtyRight: {
      display: "inline-block",
      width: 35,
      textAlign: "right",
      marginLeft: 27
    },
    colQtyLeft: {
      minWidth: 50,
      display: "inline-block"
    },
    colQtyRite: {
      minWidth: 50,
      display: "inline-block",
      marginLeft: 30,
      textAlign: "left"
    },
    pagination: {
      background: "rgba(212, 244, 248, 0.8)"
    },
    decimalFormat: {
      color: theme.palette.grey[500]
    },
    paginateFooter: {
      marginTop: 16
    },
    rowClickable: {
      cursor: "pointer"
    },
    colActive: {
      ...freezeCell,
      right: 48,
      boxShadow: "-4px 0px 6px rgb(0 0 0 / 4%)",
      paddingLeft: "8px",
      width: 48,
      "& .MuiFormControlLabel-root": {
        margin: 0
      }
    },
    colFreeze: {
      ...freezeCell
    },
    boxCancel: {
      "& .MuiTypography-root": {
        color: `${theme.palette.error.dark} !important`
      },
      background: `${theme.palette.grey[200]} !important`,
      borderRadius: 4,
      width: 72,
      padding: "3px 8px",
      userSelect: "none"
    },
    rowDisable: {
      background: "#fff !important",
      color: "#B4B4B4 ",
      "& .MuiTypography-root, td,span": {
        color: "#B4B4B4"
      },
      "& path": {
        fill: "#B4B4B4 !important"
      }
    }
  }),
  { name: "PreviewOrderNotRefTable" }
);
export default useStyles;
